/*
  Project: beautybyrockagirl.com
  Author: Piotr Rusin
 */
// import 'modules/nav';
import Splide from '@splidejs/splide';

const $ = require('jquery');
require('components-jqueryui');

const module = {
  toggleNav: function toggleNav(config) {
    const { left, $cta, ctaLeft, classToToggle } = config;
    $('.c-main-nav__container').css('left', left);
    $cta.toggleClass(classToToggle);
    $cta.css('left', ctaLeft);
  },
};

function navOpen() {
  module.toggleNav({
    left: '0',
    $cta: $(this),
    ctaLeft: '180px',
    classToToggle: 'is-active',
  });
}

$(document).on('click', '.hamburger:not(.is-active)', navOpen);

function navClose() {
  module.toggleNav({
    left: '-250px',
    $cta: $(this),
    ctaLeft: '50px',
    classToToggle: 'is-active',
  });
}

$(document).on('click', '.hamburger.is-active', navClose);

const toggleShapesAnimation = $element => {
  $element.find('.c-shape').each((shapeIndex, shapeElement) => {
    const $shape = $(shapeElement);
    $shape.toggleClass(`c-shape__${$shape.data('size')}`);
  });
};

const toggleTransform = (className, threshold) => {
  const $elements = $(`.${className}`);
  $elements.each((index, element) => {
    const $element = $(element);
    const rect = $element[0].getBoundingClientRect();
    const hasNoTransformClass = $element.hasClass(`${className}__no-transform`);
    const diff = rect.y - document.documentElement.clientHeight;
    const shouldEnable = diff < threshold;
    const shouldDisable = diff > threshold;

    if (shouldEnable && !hasNoTransformClass) {
      $element.addClass(`${className}__no-transform`);
      toggleShapesAnimation($element);
    }

    if (shouldDisable && hasNoTransformClass) {
      $element.removeClass(`${className}__no-transform`);
      toggleShapesAnimation($element);
    }
  });
};

function onNavButtonMouseEnter() {
  const $element = $(this);
  const $img = $element.find('img');
  $img.attr('src', $img.data('hover-src'));
}

function onNavButtonMouseLeave() {
  const $element = $(this);
  const $img = $element.find('img');
  $img.attr('src', $img.data('src'));
}

$('.c-main-nav-buttons a').hover(onNavButtonMouseEnter, onNavButtonMouseLeave);

function navigateTo(hash) {
  const classNames = ['c-bio', 'c-gallery__content', 'c-image-section'];
  classNames.forEach(className => {
    const $elements = $(`.${className}`);
    $elements.each((index, element) => {
      const $element = $(element);
      const noTransformClassName = `${className}__no-transform`;

      if (!$element.hasClass(noTransformClassName)) {
        $element.addClass(noTransformClassName);
        toggleShapesAnimation($element);
      }
    });
  });

  const $target = $(hash);
  const rect = $target[0].getBoundingClientRect();
  // eslint-disable-next-line radix
  const offset = rect.y > 10 ? parseInt($target.data('offset')) : 0;

  window.scroll(
    window.scrollX,
    document.documentElement.scrollTop + rect.y - offset,
  );
  // eslint-disable-next-line no-restricted-globals
  history.pushState({}, null, hash);
}

function onNavClick(e) {
  const $link = $(this);
  const href = $link.attr('href');

  if (window.location.pathname !== '/' || !href.includes('#')) {
    window.location.href = href;
  }

  e.preventDefault();

  navigateTo(href.replace('/', ''));
}

$('.c-main-nav__link').on('click', onNavClick);

window.addEventListener('load', () => {
  navigateTo(window.location.hash);
});

$(document).on('scroll', () => {
  toggleTransform('c-bio', 0);
  toggleTransform('c-gallery__content', -400);
  toggleTransform('c-gallery__content-mobile', -400);
  toggleTransform('c-image-section', 0);
});

function navMouseOver() {
  const $this = $(this);
  if (!$this.hasClass('c-main-nav-cta__arrow')) {
    $this.addClass('c-main-nav-cta__arrow');
  }
}

function navMouseLeave() {
  const $this = $(this);
  if ($this.hasClass('c-main-nav-cta__arrow')) {
    $this.removeClass('c-main-nav-cta__arrow');
  }
}

$('.c-main-nav-close')
  .on('mouseover', navMouseOver)
  .on('mouseleave', navMouseLeave);

new Splide('.splide', {
  type: 'loop',
  autoHeight: true,
  autoplay: true,
  interval: 3500,
}).mount();



// WEBPACK FOOTER //
// ./src/scripts/app.js